import React from 'react';
import { Empty } from 'antd';
import { useFunctionPipeline } from '../../../../core/modules/pipelines/hooks';
import { FunctionDetailSkeleton } from '../skeletons';
import HeroHeader from '../HeroHeader';
import ActivityTabs from './ActivityTabs';
import { RecentRunsHeader, Section } from './detail-shared';

interface IFunctionDetailProps {
  pipelineId: string;
  title: string;
  schedule: string;
  description?: string | null;
  onClose?: () => void;
}

const FunctionDetail: React.FC<IFunctionDetailProps> = ({
  pipelineId, title, schedule, description, onClose
}) => {
  const { data, isLoading, isFetching, isError } = useFunctionPipeline(pipelineId);

  if (isLoading) {
    return <FunctionDetailSkeleton />;
  }

  if (isError || !data) {
    return <Empty description='Failed to load function pipeline status' />;
  }

  const detail = data.data;
  const { current } = detail;

  return (
    <>
      <HeroHeader
        title={title}
        schedule={schedule}
        current={current}
        cacheStatus={data.cache}
        fetchedAt={data.fetched_at}
        description={description}
        onClose={onClose}
      />

      <Section>
        <RecentRunsHeader isFetching={isFetching} />
        <ActivityTabs runs={detail.runs} current={current} />
      </Section>
    </>
  );
};

export default FunctionDetail;
